// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1Cluster } from './V1Cluster';
import {
  V1ClusterFromJSON,
  V1ClusterFromJSONTyped,
  V1ClusterToJSON,
  V1ClusterToJSONTyped,
} from './V1Cluster';
import type { EnumClusterState } from './EnumClusterState';
import {
  EnumClusterStateFromJSON,
  EnumClusterStateFromJSONTyped,
  EnumClusterStateToJSON,
  EnumClusterStateToJSONTyped,
} from './EnumClusterState';

/**
 *
 * @export
 * @interface ResponseEnvironmentSpecCluster
 */
export interface ResponseEnvironmentSpecCluster {
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentSpecCluster
   */
  createdAt?: string;
  /**
   *
   * @type {V1Cluster}
   * @memberof ResponseEnvironmentSpecCluster
   */
  definition?: V1Cluster;
  /**
   *
   * @type {number}
   * @memberof ResponseEnvironmentSpecCluster
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentSpecCluster
   */
  name?: string;
  /**
   *
   * @type {EnumClusterState}
   * @memberof ResponseEnvironmentSpecCluster
   */
  state?: EnumClusterState;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentSpecCluster
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the ResponseEnvironmentSpecCluster interface.
 */
export function instanceOfResponseEnvironmentSpecCluster(
  value: object,
): value is ResponseEnvironmentSpecCluster {
  return true;
}

export function ResponseEnvironmentSpecClusterFromJSON(
  json: any,
): ResponseEnvironmentSpecCluster {
  return ResponseEnvironmentSpecClusterFromJSONTyped(json, false);
}

export function ResponseEnvironmentSpecClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentSpecCluster {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    definition:
      json['definition'] == null
        ? undefined
        : V1ClusterFromJSON(json['definition']),
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    state:
      json['state'] == null
        ? undefined
        : EnumClusterStateFromJSON(json['state']),
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function ResponseEnvironmentSpecClusterToJSON(
  json: any,
): ResponseEnvironmentSpecCluster {
  return ResponseEnvironmentSpecClusterToJSONTyped(json, false);
}

export function ResponseEnvironmentSpecClusterToJSONTyped(
  value?: ResponseEnvironmentSpecCluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at: value['createdAt'],
    definition: V1ClusterToJSON(value['definition']),
    id: value['id'],
    name: value['name'],
    state: EnumClusterStateToJSON(value['state']),
    updated_at: value['updatedAt'],
  };
}
